import React, { useEffect, useState, useRef } from "react";
import NavbarService from "../services/navbar.js";
import NavbarDropdown from "./NavbarDropdown.js";
import chevronDown from "../assets/images/chevron-down.png";
import { Link } from "react-router-dom";
import tel from "../assets/images/tel.svg";
import globe from "../assets/images/globe.svg";
import logo from "../assets/images/logo_kmutt.svg";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function Navbar(props) {
  let [navbarData, setNavbarData] = useState([]);
  let [isSearchOpen, setIsSearchOpen] = useState(false);
  const searchInputRef = useRef(null);

  let { lang } = useParams();

  const location = useLocation();

  useEffect(() => {
    closeDropdown();
    // eslint-disable-next-line
  }, [location.pathname]);

  useEffect(() => {
    getNavbarData();
  }, []);

  const getNavbarData = async () => {
    try {
      let res = await NavbarService.getNavbar();
      setNavbarData(res);
    } catch {
      console.error();
    }
  };

  // i คือ index ในรายการที่เรียงแล้ว — ห้ามเทียบกับ id เพราะ id ไม่ได้เรียงตามลำดับเมนู
  const openDropdown = (i) => {
    setNavbarData(
      navbarData.map((e, idx) => (idx === i ? { ...e, isOpen: !e.isOpen } : e))
    );
  };

  const closeDropdown = () => {
    const temp = navbarData.slice();

    const result = temp.map((e) => {
      return { ...e, isOpen: false };
    });

    setNavbarData(result);
  };

  function switchLang() {
    const currentPath = window.location.pathname;
    const currentLanguage = currentPath.split("/")[1]; // get the current language code from the path
    let newLanguage;
    if (currentLanguage === "en") {
      newLanguage = "th";
    } else if (currentLanguage === "th") {
      newLanguage = "en";
    }
    let newPath;
    if (currentPath.endsWith(`/${currentLanguage}`)) {
      // if the current path ends with "/en" or "/th", replace it with the new language code
      newPath = currentPath.replace(`/${currentLanguage}`, `/${newLanguage}`);
    } else {
      // otherwise, replace the language code in the middle of the path
      newPath = currentPath.replace(`/${currentLanguage}/`, `/${newLanguage}/`);
    }
    window.location.href = window.location.origin + newPath;
  }

  return (
    <div id="navbar" className="fixed lg:relative z-[99] w-full">
      {/* Top Bar (Teal) */}
      <div className="bg-[#1CB5B1] w-full py-[2px]">
        <div className="navbar-container flex justify-end items-center">
          <Link to={{ pathname: "https://www.kmutt.ac.th" }} target="_blank" className="flex items-center gap-[5px] text-white text-tiny hover:underline">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-[14px] w-[14px]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
            King Mongkut's University of Technology Thonburi (KMUTT)
          </Link>
        </div>
      </div>

      {/* Middle Bar (Dark Grey) */}
      <div className="bg-slateGray section">
        <div className="navbar-container py-[8px] flex justify-between items-center !z-[1]">
          <Link to={`/${lang}`}>
            {/* วัดจากเว็บ sfa: โลโก้สูง 60, เส้นคั่นห่างโลโก้ 8 / ห่างข้อความ 12,
                ชื่อ 30px + ชื่ออังกฤษ 18px ชิดล่างให้ตรงขอบล่างโลโก้ (ไม่จัดกลาง) */}
            <div className="flex items-end">
              <img className="h-[60px] w-auto" src={logo} alt="" />
              <div className="w-[1px] h-[48px] bg-white/50 ml-[8px] mr-[12px] mb-[-2px]"></div>
              <div className="flex flex-col pb-[6px]">
                <p className="text-unit text-white text-left font-normal">
                  กลุ่มงานบริการสุขภาพและอนามัย
                </p>
                <p className="text-unit-sub text-white text-left">
                  Health Care Unit
                </p>
              </div>
            </div>
          </Link>

          <div className="hidden lg:flex items-center justify-center gap-[28px]">
            <div className="flex items-center gap-[10px]">
              <img className="w-[20px]" src={tel} alt="" />
              <p className="text-body text-white">0-2470-8446</p>
            </div>

            <div
              className="flex items-center gap-[9px] cursor-pointer"
              onClick={() => {
                switchLang();
              }}
            >
              <img className="w-[22px]" src={globe} alt="" />
              <p className="text-body text-white uppercase">{lang}</p>
            </div>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-[22px] w-[22px] text-white cursor-pointer hover:text-white/70 transition-colors"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              onClick={() => {
                setIsSearchOpen(!isSearchOpen);
                setTimeout(() => {
                  searchInputRef.current?.focus();
                }, 150);
              }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* Bottom Navigation Bar (Black) */}
      <div className="hidden lg:flex items-center justify-center bg-[#2F3235]">
        <div className="navbar-container flex items-center justify-around py-[8px]">
          {navbarData &&
            navbarData.map((item, i) => (
              <div
                key={i}
                className="cursor-pointer flex gap-[8px] items-center relative"
                onClick={() => openDropdown(i)}
              >
                <Link
                  to={item.link && item.link === "-" ? "" : `/${lang}${item.link}`}
                  className={item.link && item.link === "-" ? "pointer-events-none" : undefined}
                >
                  <h1 className="capitalize text-body text-white hover:text-gray-300 whitespace-nowrap">
                    {item[`name_${lang}`]}
                  </h1>
                </Link>

                {item.subMenu && item.subMenu.length > 1 && (
                  <img
                    className={`w-[12px] cursor-pointer transition-transform ${
                      item.isOpen ? "rotate-180" : ""
                    }`}
                    src={chevronDown}
                    alt=""
                  />
                )}

                {item.subMenu && item.subMenu.length > 1 && (
                  <NavbarDropdown
                    isOpen={!item.isOpen}
                    subMenu={item.subMenu}
                    closeDropdown={closeDropdown}
                    lang={lang}
                  />
                )}
              </div>
            ))}
        </div>
      </div>

      {/* Search overlay */}
      {isSearchOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-[98]"
          onClick={() => setIsSearchOpen(false)}
        />
      )}
      <div
        className={`absolute left-0 right-0 bg-darkGray3 border-b border-white/20 z-[99] overflow-hidden transition-all duration-300 ease-in-out ${
          isSearchOpen
            ? "max-h-[120px] py-[25px] opacity-100"
            : "max-h-0 py-0 opacity-0"
        }`}
      >
        <div className="navbar-container flex items-center gap-[15px]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-white/60 flex-shrink-0"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
          <input
            ref={searchInputRef}
            type="text"
            placeholder={lang === "th" ? "พิมพ์คำค้นหา..." : "Type to search..."}
            className="bg-transparent text-white placeholder-white/50 outline-none w-full text-lead"
            onKeyDown={(e) => {
              if (e.key === "Enter" && e.target.value.trim()) {
                setIsSearchOpen(false);
                window.location.href = `/${lang}/search-keyword/${encodeURIComponent(
                  e.target.value.trim()
                )}`;
              } else if (e.key === "Escape") {
                setIsSearchOpen(false);
              }
            }}
          />
          <button
            onClick={() => setIsSearchOpen(false)}
            className="text-white/60 hover:text-white text-title leading-none flex-shrink-0 transition-colors"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}
